import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Calendar } from "lucide-react";
import Stats from "../Components/Stats";
import { getMonthlyRental, getMonthlySummary, getMonthlyType } from "../api";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Loader } from "../Components/Loader";
import { User, Wallet, ReceiptText } from "lucide-react";
import { ToastMsg } from "../Components/ToastMsg";


const kpiCards = [
  {
    label: "Total Booking Count",
    value: "count",
    icon: (
      <User className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
  {
    label: "Total Amount",
    value: "amount",
    icon: (
      <Wallet className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
  {
    label: "Total Tax",
    value: "tax",
    icon: (
      <ReceiptText className="w-7 h-7 text-[#F3B753] bg-[#232323] rounded-full p-1" />
    ),
  },
];




export default function Dashboard() {
  const [monthlyData, setMonthlyData] = useState(null);
  const[tilesData,setTilesData]=useState({})
  const [rentalDate, setRentalDate] = useState(moment());
  const[locationData,setLocationData]=useState([])

  const[month,setMonth]=useState(moment())

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment());

  // Fetch monthly summary data
  const fetchMonthlyData = async () => {
   
    try {
      setLoading(true);
      const month_ =moment(month).format("MM")// getMonth() returns 0-11
      const year_ = moment(month).format("YYYY");
      console.log("pppp",month,year_)
      setLoading(true)
      const response = await getMonthlyType(month_, year_);
     
      setMonthlyData(transformCarData(response?.data?.data?.result||[]));
    } catch (error) {
      console.error("Error fetching monthly summary:", error);
      // Fallback to default data if API fails
      ToastMsg(error?.response?.data?.message,"error")
    } finally {
      setLoading(false);
    }
  };


  const fetchMonthlyLocationWise = async () => {
   
    try {
      setLoading(true);
      const month_ =moment(rentalDate).format("MM")// getMonth() returns 0-11
      const year_ = moment(rentalDate).format("YYYY");
      
      setLoading(true)
      const response = await getMonthlyRental(month_, year_);
      console.log("result",response)
      setLocationData(transformLocationData(response?.data?.data?.result)||[]);
    } catch (error) {
      console.error("Error fetching monthly summary:", error);
      // Fallback to default data if API fails
      ToastMsg(error?.response?.data?.message,"error")
    } finally {
      setLoading(false);
    }
  };
  function transformLocationData(data) {
    return data.map(item => {
    
      return {
        name: item.location,
        y: item.current_percentage
      };
    });
  }
  console.log("setLocationData",locationData)
  useEffect(()=>{
    fetchMonthlyLocationWise()
  },[rentalDate ])
  function transformCarData(data) {
    console.log("____data",data)
    return data?.map(item => {

      return {
        name: item.car_type,
        y: item.current_percentage,
        trend: item.change_type === "increase" ? "up" : "down"
      };
    });
  }
  console.log("monthlydata",monthlyData)

  const handleCarSummar =async()=>{
    try{
      setLoading(true)
    const data = await getMonthlySummary(moment(startDate).format("MM"),moment(startDate).format("YYYY"))
    console.log("data______",data?.data?.data)
    setTilesData(data?.data?.data)
    setLoading(false)
    }catch(err){
      setLoading(false)
      ToastMsg(err?.response?.data?.message,"error")
    }
    
  }

  useEffect(() => {    
    handleCarSummar();
  }, [startDate]);

  useEffect(() => {
    // Fetch data on component mount
    
    fetchMonthlyData();
  }, [month]);

  // Dynamic chart options based on API data
  const getDonutOptions = (data) => ({
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 200,
    },
    title: { text: undefined },
    plotOptions: {
      pie: {
        innerSize: "70%",
        borderWidth: 0,
        dataLabels: { enabled: false },
      },
    },
    colors: ["#1976D2", "#43A047", "#E53935"],
    series: [
      {
        name: "Car Types",
        data: data || [
          { name: "SUV", y: 54, trend: "up" },
          { name: "Sedan", y: 20, trend: "up" },
          { name: "Hatchback", y: 26, trend: "down" },
        ],
      },
    ],
    credits: { enabled: false },
  });

  const getPlacesPieOptions = (locationData) => ({
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 320,
    },
    title: { text: undefined },
    plotOptions: {
      pie: {
        innerSize: "70%",
        borderWidth: 0,
        dataLabels: {
          enabled: false,
        },
      },
    },
    colors: ["#A259F7", "#1976D2", "#00B8D9", "#FFD600", "#F72585"],
    series: [
      {
        name: "Users",
        data: locationData || [
          { name: "Berlin", y: 30 },
          { name: "Munich", y: 20 },
          { name: "Hamburg", y: 20 },
          { name: "Frankfurt", y: 15 },
          { name: "Cologne", y: 15 },
        ],
        showInLegend: false,
      },
    ],
    credits: { enabled: false },
  });



  const handleDate = (date) => {
    setMonth(moment(date).format("YYYY-MM-DD"));
  };
  const handleRentDate = (date) => {
    setRentalDate(moment(date).format("YYYY-MM-DD"));
  };
  const handleStartDate = (date) => {
    setStartDate(moment(date).format("YYYY-MM-DD"));
  };
 
  console.log("monthlyData", monthlyData);
  if(loading) return <Loader/>

  return (
    <div className="flex flex-col gap-4 p-8 bg-[#161616] ">
      <div className="relative w-full">
              <Calendar className="w-4 h-4 top-2 left-4 absolute  text-[#F6F6F6] opacity-80" />
              <DatePicker
                className="monthPicker"
                onChange={handleStartDate}
                value={moment(startDate).format("MM-YYYY")}
                dropdownMode="select"
                placeholderText="Date"
                dateFormat="MMMM yyyy"
                showMonthYearPicker
              />
            </div>
       <div className="grid grid-cols-3 gap-10">
          {kpiCards.map((card, i) => (
            <div
              key={i}
              className="bg-[#181818] border border-[#232323] rounded-xl flex flex-col justify-between px-[33px] py-4 min-h-[120px]"
            >
              <div className="flex flex-row items-center justify-between w-full">
                <div className="text-2xl font-bold text-left">{card.value==="count"?(tilesData?.total_bookings):card?.value==="amount"?(tilesData?.total_amount):(tilesData?.total_tax)}</div>
                <div className="bg-[#232323] rounded-full p-2 flex items-center justify-center">
                  {card.icon}
                </div>
              </div>
              <div className="text-[#bdbdbd] text-sm mt-2 text-left">
                {card.label}
              </div>
            </div>
          ))}
        </div>
      <div className="grid grid-cols-3 gap-10 mt-4">
        <div className="bg-[#181818] border border-[#232323] rounded-xl p-4 flex flex-col h-[24rem]">
          <div className="flex items-center justify-between mb-4">
            <div className="w-[100px]">
            <span className="text-sm text-[#bdbdbd] font-medium">
              Top Car 
            </span>
            </div>
            <div className="relative w-full">
              <Calendar className="w-4 h-4 top-2 left-4 absolute  text-[#F6F6F6] opacity-80" />
              <DatePicker
                className="monthPicker"
                onChange={handleDate}
                value={moment(month).format("MM-YYYY")}
                dropdownMode="select"
                placeholderText="Date"
                dateFormat="MMMM yyyy"
                showMonthYearPicker
              />
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-[200px] h-[200px] mb-4">
              {(Array.isArray(monthlyData) && monthlyData.length > 0) ? (
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getDonutOptions(monthlyData)}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-[#bdbdbd] text-lg mb-2">📊</div>
                    <div className="text-[#bdbdbd] text-sm">No data available</div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex flex-col gap-2 w-full">
              {(Array.isArray(monthlyData) && monthlyData.length > 0) ?
               (
                (Array.isArray(monthlyData) ? monthlyData : getDonutOptions().series[0].data).map(
                (item, idx) => (
                  <div
                    key={item.name}
                    className="flex flex-row items-center justify-between w-full"
                  >
                    <div className="flex flex-row items-center gap-2">
                      <span
                        className="w-3 h-3 rounded-full inline-block"
                        style={{
                          backgroundColor: getDonutOptions().colors[idx],
                        }}
                      />
                      <span className="text-sm text-white">{item.name}</span>
                    </div>
                    <div className="flex flex-row items-center gap-1">
                      <span className="text-sm text-white">{item.y}%</span>
                      {item.trend === "up" ? (
                        <span className="text-xs font-bold text-green-500">
                          ↑
                        </span>
                      ) : (
                        <span className="text-xs font-bold text-red-500">
                          ↓
                        </span>
                      )}
                    </div>
                  </div>
                )
              ) ): (
                <div className="text-center py-4">
                  <div className="text-[#bdbdbd] text-sm">No car type data available</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="bg-[#181818] border border-[#232323] rounded-xl p-4 flex flex-row h-full gap-6 col-span-2">
          <div className="flex-1 flex flex-col">
            <div className="flex items-center gap-10 mb-6">
              <div className="w-[195px]">
              <span className="text-sm text-[#bdbdbd]  font-medium ">
                Top Rental Locations
              </span>
              </div>

              <div className="relative w-full">
                <Calendar className="w-4 h-4 top-2 left-4 absolute  text-[#F6F6F6] opacity-80" />
                <DatePicker
                  className="monthPicker"
                  onChange={handleRentDate}
                  value={moment(rentalDate).format("MM-YYYY")}
                  dropdownMode="select"
                  placeholderText="Date"
                  dateFormat="MMMM yyyy"
                  showMonthYearPicker
                />
              </div>
            </div>
            <div className="flex flex-row w-full h-full gap-4">
              <div className="flex flex-col w-[270px]">
                {/* <div className="text-white text-sm font-medium mb-1 text-left">
                  Users by places
                </div>
                <div className="flex items-center gap-2 mb-[22px]">
                  <span className="text-base font-semibold">
                    {loading
                      ? "..."
                      : `${monthlyData?.total_booking_count || 12400}`}
                  </span>
                  <span className="bg-green-900 text-green-400 text-xs px-2 py-1 rounded">
                    28.5% ↑
                  </span>
                </div> */}
                <div className="flex flex-col gap-4">
                  {(locationData  && locationData?.length > 0) ? (
                    locationData.map((place, idx) => (
                      <div key={place.name} className="flex flex-col gap-1">
                        <div className="flex flex-row justify-between items-center w-full">
                          <span className="text-white text-xs">{place.name}</span>
                          <span className="text-white text-xs">{place.y}%</span>
                        </div>
                        <div className="w-full h-2 bg-[#232323] rounded">
                          <div
                            className="h-1 rounded"
                            style={{
                              width: `${place.y}%`,
                              backgroundColor: getPlacesPieOptions().colors[idx],
                            }}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-4">
                      <div className="text-[#bdbdbd] text-sm">No location data available</div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex-1 flex items-center justify-end">
                <div className="w-[320px] h-[320px]">
                  {(locationData && locationData?.length > 0) ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={getPlacesPieOptions(locationData)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <div className="text-center">
                        <div className="text-[#bdbdbd] text-lg mb-2">📍</div>
                        <div className="text-[#bdbdbd] text-sm">No location data available</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
